module.exports = __webpack_public_path__ + "static/HomePageGIF_Solution-86be5a709bf433801e3ab3eb1b85ede3.gif";